module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Vice.952cb6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Vice.jpg
// module id = IG7p
// module chunks = 0